import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AsyncCallHandler from '../common/AsyncCallHandler'
import ACTION_TYPES from '../actions/actionTypes'
import NEXUS_CONST from '../common/constants'
const initialState = { siteLocations: [], tiers: [], userDetails: {}, pinSiteStatus: null, pinnedSites: [] };
export const fetchSiteLocations = createAsyncThunk(ACTION_TYPES.FETCH_SBG_LOCATIONS, async (sbg) => {
    let response = await AsyncCallHandler(NEXUS_CONST.SITE_LOCATION_URL + sbg, NEXUS_CONST.GET)
    return response.data;
})
export const fetchPinnedSites = createAsyncThunk(ACTION_TYPES.FETCH_PINNED_SITES, async (sbg) => {
    let response = await AsyncCallHandler(NEXUS_CONST.FETCH_PINNED_SITES + sbg, NEXUS_CONST.GET)
    return response.data;
})
export const getUserData = createAsyncThunk(ACTION_TYPES.GET_USER_DATA, async (site) => {
    let response = await AsyncCallHandler(NEXUS_CONST.GET_USER_DATA + site, NEXUS_CONST.GET)
    return response.data;
})

let SettingsReducer = createSlice({
    initialState,
    name: 'settings',
    reducers: {
        add: (state, action) => {
            state.data = state.data + 6
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSiteLocations.fulfilled, (state, action) => {
            state.siteLocations = action.payload
        }).addCase(fetchPinnedSites.fulfilled, (state, action) => {
            state.pinnedSites = action.payload
        }).addCase(getUserData.fulfilled, (state, action) => {
            state.userDetails = action.payload
        })
    },
})
export const { add } = SettingsReducer.actions;
export default SettingsReducer.reducer;